/* eslint-disable default-param-last */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { TableCell, TableRow, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import tableStyle from "../../../../theme/styles/table";
import CustomTable from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import Modal from "../../../../components/common/Modal/Modal";
import Button from "../../../../components/common/Button";
import styles from "./OrganizationStructure.styles";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
import { Constants } from "../../../../contants";
import Member from "../../../../services/api/member";
import { performOperation } from "../../../member/MemberSearch/utils";
import InputField from "../../../../components/common/new/InputField/InputField";
import { isInteger } from "../../../../utils";
import Loader from "../../../../components/common/Loader/Loader";
import SelectMemberModal from "./SelectMemberModal";
import SelectMemberModalSpecialGroup from "./SelectMemberModalSpecialGroup";

const DIRECT_APPOINTMENT_COL = [
  {
    displayName: "MEMBER ID",
    key: "memberId",
  },
  {
    displayName: "MEMBER NAME",
    key: "memberName",
  },
  {
    displayName: "EMAIL",
    key: "email",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

function SearchResultNationalSpecial({
  open,
  onClose,
  appointedMembers,
  payload,
  isUHG,
}) {
  const [searchResult, setSearchResult] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMemberData, setSelectedMemberData] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const type = payload && payload.type ? payload.type : null;

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const acceptAppointmentHandler = (memberId) => {
    const memberData = searchResult.find((item) => item.memberId === memberId);
    setSelectedMemberId(memberId);
    setSelectedMemberData([memberData]);
    setOpenAlert(true);
  };

  const handleSearch = async (
    payload,
    page = 0,
    size = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const { positionId, divisionId, subDivisionId } = appointedMembers[0];
      let result;
      if (isUHG) {
        result = await Member.structureLeadersUHG({
          ...payload,
          page,
          size,
          positionId,
          fullName: isInteger(searchValue) ? "" : searchValue,
          memberId:
            searchValue && isInteger(searchValue) ? Number(searchValue) : "",
        });
      } else {
        result = await Member.structureLeadersSpecialGroup({
          page,
          size,
          positionId,
          divisionId,
          subDivisionId,
          fullName: isInteger(searchValue) ? "" : searchValue,
          memberId:
            searchValue && isInteger(searchValue) ? Number(searchValue) : "",
        });
      }
      const { content, totalPages, totalElements } = result.data;
      setSearchResult(content);
      setCurrentPage(page);
      setTotalPages(totalPages);
      setTotalElements(totalElements);
      setSize(size);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const onPaginationClick = (page) => {
    handleSearch(payload, Number(page), size);
  };

  const onPageSizeClick = (operator) => {
    const newPageSize = performOperation(
      size,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    handleSearch(payload, 0, newPageSize);
  };

  const getRows = () => {
    if (!Array.isArray(searchResult)) {
      return null;
    }

    return searchResult.map((item) => (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={styles.rowStyle}>{item.memberId || "NA"}</TableCell>
        <TableCell style={styles.rowStyle}>{item.fullName || "NA"}</TableCell>
        <TableCell style={styles.rowStyle}>{item.emailId || "NA"}</TableCell>
        <TableCell style={styles.rowStyle}>
          <Button
            variant="outlined"
            style={styles.actionBtn}
            type="submit"
            label="APPOINT"
            onClick={() => acceptAppointmentHandler(item.memberId)}
          />
        </TableCell>
      </TableRow>
    ));
  };

  const rows = getRows();

  useEffect(() => {
    if (open) {
      handleSearch(payload, 0, Constants.DEFAULT_PAGE_SIZE);
    }
  }, [open, payload]);
  useEffect(() => {
    let timeoutId;
    if (open) {
      timeoutId = setTimeout(() => {
        handleSearch(payload, 0, Constants.DEFAULT_PAGE_SIZE);
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [searchValue]);

  useEffect(() => {
    if (!open) {
      setSearchValue("");
    }
  }, [open]);

  return (
    <Modal open={open}>
      <Box style={styles.container}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Typography component="p" color="#8C8C8C" weight={500} my={4} />
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </Box>
        <Box style={{ display: "flex", gap: "1rem" }} />
        {open && (
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Box justifyContent="center">
              <Typography component="p" color="#8C8C8C" weight={500} my={4}>
                Eligible Members for {appointedMembers[0]?.positionName}
              </Typography>
            </Box>
            <Box width="50%">
              <InputField
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                label="Search Member Name / ID"
              />
            </Box>
          </Box>
        )}
        <div
          style={{
            maxHeight: "65vh",
            overflow: "auto",
          }}
        >
          <CustomTable
            columnCellStyle={{ textAlign: "center" }}
            scrollable
            columns={DIRECT_APPOINTMENT_COL}
            rows={rows}
            isLoading={isLoading}
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...styles.tableHeadCells,
            }}
          />
        </div>
        {searchResult.length > 0 && open ? (
          <Box style={styles.pagination}>
            <Pagination
              totalPages={totalPages}
              totalResults={totalElements}
              currentPage={currentPage}
              pageSize={size}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        ) : (
          <Box style={styles.emptyContainer}>
            <h1 style={styles.noDataMsg}>No Results</h1>
          </Box>
        )}
        {isLoading && <Loader />}
        {type === "adhoc" ? (
          <SelectMemberModal
            open={openAlert}
            onClose={() => {
              toggleAlert();
              onClose();
            }}
            selectedMemberData={selectedMemberData}
            appointedMembers={appointedMembers}
            selectedMemberId={selectedMemberId}
            type={type}
          />
        ) : (
          <SelectMemberModalSpecialGroup
            open={openAlert}
            onClose={() => {
              toggleAlert();
              onClose();
            }}
            selectedMemberData={selectedMemberData}
            appointedMembers={appointedMembers}
            selectedMemberId={selectedMemberId}
          />
        )}
      </Box>
    </Modal>
  );
}

export default SearchResultNationalSpecial;
